import { render, staticRenderFns } from "./RecordingDetail.vue?vue&type=template&id=352f1d0e&scoped=true"
import script from "./RecordingDetail.vue?vue&type=script&lang=js"
export * from "./RecordingDetail.vue?vue&type=script&lang=js"
import style0 from "./RecordingDetail.vue?vue&type=style&index=0&id=352f1d0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352f1d0e",
  null
  
)

export default component.exports